/** Decimal places when the card has no precision; matches the editor's default option. */
export const NUMBER_DEFAULT_PRECISION = 2;

/** Precision locks both min and max fraction digits, so 0 shows no decimals. */
export function resolveNumberFractionDigits(precision: number): {
	minimumFractionDigits: number;
	maximumFractionDigits: number;
} {
	const safePrecision = Number.isFinite(precision)
		? Math.max(0, Math.trunc(precision))
		: NUMBER_DEFAULT_PRECISION;
	return {
		minimumFractionDigits: safePrecision,
		maximumFractionDigits: safePrecision,
	};
}
